/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput';

export class RestoreEksNamespaceConfig {
  /**
  * Optional tags to apply to the output volume
  */
  'tags'?: { [key: string]: string; };
  'volumeSettings'?: Array<RestoreEksNamespaceVolumeInput>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "volumeSettings",
      "baseName": "volumeSettings",
      "type": "Array<RestoreEksNamespaceVolumeInput>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreEksNamespaceConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

